import { createContext } from "react";
const globalEditContext = createContext([false]);
export {
  globalEditContext
};
